/* Achieved custom storefront — cart drawer, quick add, wishlist, search, builder, motion.
   Talks to Shopify's Ajax Cart API; config comes from window.ACH (layout/theme.liquid). */
(() => {
  const C = window.ACH, S = C.strings;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const url = p => C.root + p;
  const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const tr = (s, vars) => s.replace(/\[(\w+)\]/g, (m, k) => k in vars ? vars[k] : m);

  /* ---------- money ---------- */
  function money(cents) {
    const n = (cents || 0) / 100;
    const fix = (d, th, dec) => { const [i, f] = n.toFixed(d).split("."); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : ""); };
    return C.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2, ",", "."), amount_no_decimals: fix(0, ",", "."),
      amount_with_comma_separator: fix(2, ".", ","), amount_no_decimals_with_comma_separator: fix(0, ".", ","),
      amount_with_apostrophe_separator: fix(2, "'", "."), amount_with_space_separator: fix(2, " ", ",")
    }[k] ?? fix(2, ",", ".")));
  }

  /* ---------- overlays ---------- */
  const scrim = $("#AchScrim");
  function open(sel) { closeAll(true); $(sel).classList.add("on"); scrim.classList.add("on"); document.body.style.overflow = "hidden"; if (sel === "#AchSearch") setTimeout(() => $("#AchQ").focus(), 200); }
  function closeAll(keep) { $$(".ach-drawer,.ach-search").forEach(d => d.classList.remove("on")); if (!keep) { scrim.classList.remove("on"); document.body.style.overflow = ""; } }
  scrim.addEventListener("click", () => closeAll());
  document.addEventListener("click", e => {
    if (e.target.closest("[data-ach-close]")) closeAll();
    if (e.target.closest("[data-ach-open-cart]")) { e.preventDefault(); refreshCart().then(() => open("#AchCart")); }
    if (e.target.closest("[data-ach-open-wish]")) { e.preventDefault(); renderWish(); open("#AchWish"); }
    if (e.target.closest("[data-ach-open-search]")) { e.preventDefault(); open("#AchSearch"); }
    const burger = e.target.closest("[data-ach-burger]");
    if (burger) { const m = $("#AchMobile"); m.classList.toggle("on"); burger.setAttribute("aria-expanded", m.classList.contains("on")); }
  });
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") closeAll();
    if (e.key === "/" && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) { e.preventDefault(); open("#AchSearch"); }
  });

  /* ---------- toast ---------- */
  function toast(msg, img, act, fn) {
    const box = $("#AchToasts"), t = document.createElement("div");
    t.className = "ach-toast";
    t.innerHTML = `${img ? `<img src="${esc(img)}" alt="">` : ""}<span>${esc(msg)}</span>${act ? `<button type="button">${esc(act)}</button>` : ""}`;
    const kill = () => { t.classList.add("out"); setTimeout(() => t.remove(), 300); };
    if (act) t.querySelector("button").onclick = () => { fn(); kill(); };
    box.appendChild(t); while (box.children.length > 3) box.firstChild.remove();
    setTimeout(kill, 3400);
  }

  /* ---------- cart ---------- */
  let cart = null;
  const badge = $("#AchCartCount");
  function bump(el) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
  async function api(path, body) {
    const r = await fetch(url(path), body ? { method: "POST", headers: body instanceof FormData ? { Accept: "application/json" } : { "Content-Type": "application/json", Accept: "application/json" }, body: body instanceof FormData ? body : JSON.stringify(body) } : { headers: { Accept: "application/json" } });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || "Error");
    return j;
  }
  async function refreshCart() { cart = await api("cart.js"); renderCart(); return cart; }

  function flyTo(from) {
    const target = $("[data-ach-open-cart]");
    if (!from || !target) return bump(badge);
    const f = from.getBoundingClientRect(), t = target.getBoundingClientRect(), d = document.createElement("div");
    d.className = "ach-fly"; document.body.appendChild(d);
    const x0 = f.left + f.width / 2, y0 = f.top + f.height / 2, x1 = t.left + t.width / 2, y1 = t.top + t.height / 2;
    d.animate([{ transform: `translate(${x0}px,${y0}px)` }, { transform: `translate(${(x0 + x1) / 2}px,${Math.min(y0, y1) - 120}px) scale(1.3)`, offset: .5 }, { transform: `translate(${x1}px,${y1}px) scale(.3)` }], { duration: 700, easing: "cubic-bezier(.5,0,.3,1)" }).onfinish = () => { d.remove(); bump(badge); };
  }

  async function add(items, from) {
    try {
      const res = await api("cart/add.js", items instanceof FormData ? items : { items });
      const added = res.items ? res.items[0] : res;
      flyTo(from); await refreshCart();
      if (items instanceof FormData) open("#AchCart");
      else toast(tr(S.added, { title: added.product_title }), added.image, S.viewCart, () => open("#AchCart"));
    } catch (err) { toast(err.message); }
  }

  function renderCart() {
    if (!cart) return;
    const n = cart.item_count;
    badge.textContent = n; badge.classList.toggle("on", n > 0);
    $("#AchCartN").textContent = n ? `(${n})` : "";
    const ship = $("#AchShip"), total = cart.total_price, free = C.freeShip;
    if (n && free > 0) {
      const left = Math.max(0, free - total);
      ship.style.display = "";
      ship.innerHTML = (left ? tr(S.shipLeft, { amount: `<b class="ach-tab">${money(left)}</b>` }) : S.shipFree) +
        `<div class="ach-bar ${left ? "" : "full"}"><i style="width:${Math.min(100, total / free * 100)}%"></i></div>`;
    } else ship.style.display = "none";
    $("#AchLines").innerHTML = n ? cart.items.map((l, i) => {
      const props = Object.entries(l.properties || {}).filter(([k, v]) => v && !k.startsWith("_")).map(([k, v]) => `${esc(k)}: ${esc(v)}`);
      const sub = [l.variant_title, ...props].filter(Boolean).join(" · ");
      return `<div class="ach-lineitem" data-line="${i + 1}">
        <a href="${esc(l.url)}"><img src="${esc(l.image || "")}" alt=""></a>
        <div><h4><a href="${esc(l.url)}">${esc(l.product_title)}</a></h4>${sub ? `<small>${sub}</small>` : ""}
          <div class="ach-qty"><button type="button" data-d="-1" aria-label="−">−</button><span class="ach-tab">${l.quantity}</span><button type="button" data-d="1" aria-label="+">+</button></div></div>
        <div class="ach-r"><span>${l.original_line_price > l.final_line_price ? `<s class="ach-tab" style="display:block;font-size:12px;color:#a8a29e">${money(l.original_line_price)}</s>` : ""}<b class="ach-tab">${money(l.final_line_price)}</b></span><button type="button" class="ach-rm" data-rm>${esc(S.remove)}</button></div></div>`;
    }).join("") : `<div class="ach-empty-cart"><b>${esc(S.emptyTitle)}</b>${esc(S.emptyText)}<br><br><a class="ach-btn ach-btn-dark" style="width:auto" href="${esc(C.shopUrl)}" data-ach-close>${esc(S.startShopping)}</a></div>`;
    $("#AchCartFoot").style.display = n ? "" : "none";
    const disc = Math.max(0, cart.original_total_price - cart.total_price);
    $("#AchSub").textContent = money(cart.original_total_price);
    $("#AchDiscRow").style.display = disc ? "" : "none";
    $("#AchDisc").textContent = "−" + money(disc);
    $("#AchTot").textContent = money(total);
  }

  $("#AchLines").addEventListener("click", async e => {
    const row = e.target.closest(".ach-lineitem"); if (!row) return;
    const line = +row.dataset.line, item = cart.items[line - 1];
    const d = e.target.closest("[data-d]");
    if (d) {
      const q = item.quantity + +d.dataset.d;
      if (q < 1) return removeLine(row, line, item);
      try { cart = await api("cart/change.js", { line, quantity: q }); renderCart(); } catch (err) { toast(err.message); }
    }
    if (e.target.closest("[data-rm]")) removeLine(row, line, item);
  });
  async function removeLine(row, line, item) {
    row.classList.add("out");
    try {
      cart = await api("cart/change.js", { line, quantity: 0 });
      setTimeout(() => {
        renderCart();
        toast(tr(S.removed, { title: item.product_title }), null, S.undo, () => add([{ id: item.variant_id, quantity: item.quantity, properties: item.properties || {} }]));
      }, 300);
    } catch (err) { row.classList.remove("out"); toast(err.message); }
  }

  /* discount: /discount/CODE stores the code on the session, Shopify applies it at checkout */
  const promoBtn = $("#AchApplyPromo");
  if (promoBtn) {
    const applyPromo = async () => {
      const code = $("#AchPromo").value.trim(); if (!code) return;
      await fetch(url("discount/" + encodeURIComponent(code)), { credentials: "same-origin" }).catch(() => {});
      await refreshCart();
      $("#AchPromo").value = code.toUpperCase();
      toast(tr(S.codeSaved, { code: code.toUpperCase() }));
    };
    promoBtn.onclick = applyPromo;
    $("#AchPromo").addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); applyPromo(); } });
  }

  /* Intercept every add-to-cart form (product pages included) so it lands in our drawer */
  document.addEventListener("submit", e => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const btn = form.querySelector('[type="submit"]');
    btn?.classList.add("loading"); btn?.setAttribute("aria-disabled", "true");
    add(new FormData(form), btn).finally(() => { btn?.classList.remove("loading"); btn?.removeAttribute("aria-disabled"); });
  }, true);

  /* Quick add on cards */
  document.addEventListener("click", e => {
    const q = e.target.closest("[data-ach-add]"); if (!q) return;
    e.preventDefault(); e.stopPropagation();
    add([{ id: +q.dataset.achAdd, quantity: 1 }], q);
  });

  /* ---------- wishlist (stored in the browser) ---------- */
  const WKEY = "ach_wish";
  let wish = JSON.parse(localStorage.getItem(WKEY) || "[]");
  const wBadge = $("#AchWishCount");
  const saveWish = () => { localStorage.setItem(WKEY, JSON.stringify(wish)); wBadge.textContent = wish.length; wBadge.classList.toggle("on", wish.length > 0); };
  const syncHearts = () => $$("[data-ach-wish]").forEach(b => b.classList.toggle("on", wish.some(w => w.h === JSON.parse(b.dataset.achWish).h)));
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-ach-wish]"); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const item = JSON.parse(b.dataset.achWish), on = !wish.some(w => w.h === item.h);
    wish = on ? [...wish, item] : wish.filter(w => w.h !== item.h);
    saveWish(); syncHearts(); renderWish();
    if (on) b.animate([{ transform: "scale(1)" }, { transform: "scale(1.4)" }, { transform: "scale(1)" }], { duration: 400 });
    toast(on ? S.wishAdded : S.wishRemoved, item.i);
  });
  function renderWish() {
    $("#AchWishLines").innerHTML = wish.length ? wish.map(w => `
      <div class="ach-lineitem"><a href="${esc(w.u)}"><img src="${esc(w.i)}" alt=""></a>
        <div><h4><a href="${esc(w.u)}">${esc(w.t)}</a></h4><small class="ach-tab">${esc(w.p)}</small>
          ${w.v ? `<button type="button" class="ach-btn ach-btn-dark" style="padding:9px 14px;font-size:13px;margin-top:10px;width:auto" data-ach-add="${w.v}">${esc(S.addToCart)}</button>` : `<a class="ach-btn ach-btn-dark" style="padding:9px 14px;font-size:13px;margin-top:10px;width:auto" href="${esc(w.u)}">${esc(S.chooseOptions)}</a>`}</div>
        <div class="ach-r"><button type="button" class="ach-rm" data-ach-wish='${esc(JSON.stringify(w))}'>${esc(S.remove)}</button></div></div>`).join("")
      : `<div class="ach-empty-cart"><b>${esc(S.wishEmptyTitle)}</b>${esc(S.wishEmptyText)}</div>`;
  }

  /* ---------- predictive search ---------- */
  const thumb = u => u ? u + (u.includes("?") ? "&" : "?") + "width=120" : "";
  let sTimer;
  $("#AchQ").addEventListener("input", e => {
    clearTimeout(sTimer);
    const q = e.target.value.trim(), box = $("#AchSres");
    if (!q) { box.innerHTML = ""; return; }
    sTimer = setTimeout(async () => {
      try {
        const r = await fetch(`${C.searchUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
        const items = (await r.json()).resources.results.products || [];
        box.innerHTML = items.length ? items.map(p => `<a href="${esc(p.url)}"><img src="${esc(thumb(p.image || p.featured_image?.url || ""))}" alt="" loading="lazy"><span><b>${esc(p.title)}</b><small class="ach-tab">${money(Math.round(parseFloat(p.price) * 100))}</small></span></a>`).join("")
          : `<p style="color:var(--ach-stone);grid-column:1/-1">${esc(tr(S.noResults, { q }))}</p>`;
      } catch { box.innerHTML = ""; }
    }, 180);
  });

  /* ---------- shop grid: filters + sort ---------- */
  $$("[data-ach-shop]").forEach(shop => {
    const grid = $(".ach-grid", shop), cards = $$(".ach-card", grid);
    let f = $(".ach-chip.on", shop)?.dataset.f || "all";
    const apply = () => {
      const s = $("select", shop)?.value || "feat";
      const sorted = [...cards].sort((a, b) => (a.classList.contains("ach-bcard") - b.classList.contains("ach-bcard")) || (s === "lo" ? a.dataset.price - b.dataset.price : s === "hi" ? b.dataset.price - a.dataset.price : s === "az" ? a.dataset.title.localeCompare(b.dataset.title) : a.dataset.idx - b.dataset.idx));
      let shown = 0;
      sorted.forEach((c, i) => { const ok = f === "all" || c.dataset.type === f; c.hidden = !ok; if (ok) { c.style.animationDelay = (shown++ * 40) + "ms"; c.style.animation = "none"; void c.offsetWidth; c.style.animation = ""; } grid.appendChild(c); });
      const em = $(".ach-empty", shop); if (em) em.hidden = shown > 0;
      const bh = $("[data-ach-bottle]", shop);
      if (bh) { const on = f === "water-bottle"; if (on && bh.hidden) { bh.hidden = false; bh.classList.remove("in"); void bh.offsetWidth; bh.classList.add("in"); } else if (!on) bh.hidden = true; }
    };
    apply();
    shop.achFilter = k => { const ch = $(`.ach-chip[data-f="${k}"]`, shop); if (ch && !ch.classList.contains("on")) ch.click(); };
    $$(".ach-chip", shop).forEach(ch => ch.addEventListener("click", () => { $$(".ach-chip", shop).forEach(x => x.classList.toggle("on", x === ch)); f = ch.dataset.f; apply(); }));
    $("select", shop)?.addEventListener("change", apply);
    $$("[data-ach-jump]").forEach(a => a.addEventListener("click", () => { const ch = $(`.ach-chip[data-f="${a.dataset.achJump}"]`, shop); ch?.click(); }));
  });

  /* ---------- water bottle designer ---------- */
  $$("[data-ach-bottle]").forEach(bh => {
    const shop = bh.closest("[data-ach-shop]"), svg = $(".ach-bottle-svg", bh), wrap = $(".ach-bwrap", bh);
    const txt = $(".ach-btxt", bh), sizeTag = $(".ach-bsize-tag", bh), cname = $(".ach-bcname", bh);
    const paint = (sel, attr, val) => $$(`[data-p="${sel}"]`, svg).forEach(el => el.setAttribute(attr, val));
    const setColour = sw => {
      $$(".ach-sw", bh).forEach(x => x.classList.toggle("on", x === sw));
      paint("body", "fill", sw.dataset.body); paint("cap", "fill", sw.dataset.cap); paint("ink", "fill", sw.dataset.ink);
      cname.textContent = sw.dataset.name; bh.style.setProperty("--bglow", sw.dataset.body === "#141414" ? sw.dataset.cap : sw.dataset.body);
      wrap.classList.remove("pop"); void wrap.offsetWidth; wrap.classList.add("pop");
    };
    const setText = v => { const t = (v || "").toUpperCase().slice(0, 12); $('[data-p2="txt"]', svg).textContent = t; $$(".ach-bquick button", bh).forEach(b => b.classList.toggle("on", b.dataset.q === t)); };
    $$(".ach-sw", bh).forEach(sw => sw.addEventListener("click", () => setColour(sw)));
    $$(".ach-bsize button", bh).forEach(b => b.addEventListener("click", () => {
      $$(".ach-bsize button", bh).forEach(x => x.classList.toggle("on", x === b));
      wrap.classList.toggle("big", b.dataset.z === "750"); sizeTag.textContent = b.textContent;
    }));
    txt.addEventListener("input", () => setText(txt.value));
    $$(".ach-bquick button", bh).forEach(b => b.addEventListener("click", () => { txt.value = b.dataset.q; setText(b.dataset.q); }));
    $$(".ach-bpick", shop).forEach(b => b.addEventListener("click", () => {
      shop.achFilter?.("water-bottle");
      const sw = $(`.ach-sw[data-k="${b.dataset.k}"]`, bh); if (sw) setColour(sw);
      bh.scrollIntoView({ behavior: "smooth", block: "start" });
    }));
    $(".ach-bnotify", bh).addEventListener("click", () => {
      const form = $$("form").find(f => f.querySelector('input[name="contact[email]"]') && f.closest(".ach-news"));
      if (!form) return;
      const tags = form.querySelector('input[name="contact[tags]"]'); if (tags) tags.value = "newsletter,bottle-waitlist";
      const email = form.querySelector('input[name="contact[email]"]');
      form.scrollIntoView({ behavior: "smooth", block: "center" }); setTimeout(() => email.focus({ preventScroll: true }), 500);
      toast(window.ACH?.strings?.bottleJoin || "");
    });
  });

  /* ---------- product page ---------- */
  $$("[data-ach-pdp]").forEach(pdp => {
    const cfg = JSON.parse($("[data-ach-variants]", pdp).textContent);
    const form = $("[data-ach-pform]", pdp), idInput = $("[data-variant-id]", pdp), addBtn = $("[data-add]", pdp);
    const mainImg = $(".ach-gimg", pdp), qty = $('input[name="quantity"]', pdp), sticky = $("[data-ach-sticky]", pdp);
    const setImg = src => { if (!src || !mainImg || mainImg.src === src) return; mainImg.style.opacity = 0; setTimeout(() => { mainImg.src = src; mainImg.removeAttribute("srcset"); mainImg.style.opacity = 1; }, 150); };
    $$(".ach-thumbs button", pdp).forEach(b => b.addEventListener("click", () => { $$(".ach-thumbs button", pdp).forEach(x => x.classList.toggle("on", x === b)); setImg(b.dataset.src); }));
    $$("[data-qd]", pdp).forEach(b => b.addEventListener("click", () => { qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + +b.dataset.qd)); }));
    const segs = $$("[data-option]", pdp);
    const update = () => {
      const chosen = segs.map(sg => $("button.on", sg)?.dataset.value);
      const v = cfg.variants.find(x => x.options.every((o, i) => o === chosen[i]));
      if (!v) { addBtn.disabled = true; $("span", addBtn).textContent = cfg.soldOut; return; }
      idInput.value = v.id;
      $$("[data-price]", pdp).forEach(el => el.textContent = money(v.price));
      const cmp = $("[data-compare]", pdp), save = $("[data-save]", pdp);
      cmp.hidden = !(v.compare > v.price); cmp.textContent = money(v.compare);
      save.hidden = !(v.compare > v.price); save.textContent = tr(cfg.save, { amount: money(v.compare - v.price) });
      addBtn.disabled = !v.available; $("span", addBtn).textContent = v.available ? cfg.add : cfg.soldOut;
      const sb = $("[data-sticky-add]", pdp); if (sb) sb.disabled = !v.available;
      setImg(v.img);
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    };
    segs.forEach(sg => $$("button", sg).forEach(b => b.addEventListener("click", () => { $$("button", sg).forEach(x => x.classList.toggle("on", x === b)); update(); })));
    form.addEventListener("submit", () => { addBtn.classList.add("loading"); setTimeout(() => addBtn.classList.remove("loading"), 1500); });
    if (sticky) {
      sticky.hidden = false;
      const check = () => sticky.classList.toggle("on", addBtn.getBoundingClientRect().bottom < 0);
      addEventListener("scroll", check, { passive: true }); check();
      $("[data-sticky-add]", sticky).addEventListener("click", () => form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click());
    }
  });

  /* ---------- collection sort (server-side) ---------- */
  $$("[data-ach-sortlink]").forEach(sel => sel.addEventListener("change", e => {
    e.stopImmediatePropagation();
    const u = new URL(location.href); u.searchParams.set("sort_by", sel.value); u.searchParams.delete("page"); location.href = u;
  }, true));

  /* ---------- sticker builder ---------- */
  $$("[data-ach-builder]").forEach(b => {
    const cfg = JSON.parse($("script[type='application/json']", b).textContent);
    let sport = Object.keys(cfg.sports)[0], finish = $(".ach-finish .on", b)?.dataset.f;
    const dist = $(".ach-dist", b), tag = $(".ach-tag", b), img = $(".ach-preview img", b), btn = $(".ach-badd", b);
    const render = pop => {
      const s = cfg.sports[sport];
      $(".ach-quickpicks", b).innerHTML = s.q.map(v => `<button type="button" data-v="${v}" class="${dist.value === v ? "on" : ""}">${v} KM</button>`).join("");
      tag.textContent = `${cfg.label} · ${(dist.value || "0").replace(",", ".")} KM`;
      tag.style.color = $(".ach-finish .on", b).dataset.c;
      if (pop) { tag.classList.remove("pop"); void tag.offsetWidth; tag.classList.add("pop"); }
      $(".ach-bprice", b).innerHTML = s.price ? `<b class="ach-tab">${money(s.price)}</b>${s.compare > s.price ? `<s class="ach-tab">${money(s.compare)}</s>` : ""}` : "";
      btn.disabled = !s.variant; btn.textContent = s.variant ? cfg.addLabel : cfg.soonLabel;
    };
    $(".ach-sport", b).addEventListener("click", e => {
      const t = e.target.closest("button"); if (!t) return;
      $$(".ach-sport button", b).forEach(x => x.classList.toggle("on", x === t)); sport = t.dataset.s;
      img.style.opacity = 0; setTimeout(() => { img.src = cfg.sports[sport].img; img.style.opacity = 1; }, 200);
      dist.value = cfg.sports[sport].q[2]; render(true);
    });
    $(".ach-quickpicks", b).addEventListener("click", e => { const t = e.target.closest("button"); if (t) { dist.value = t.dataset.v; render(true); } });
    dist.addEventListener("input", () => { dist.value = dist.value.replace(/[^\d.,]/g, ""); render(false); });
    $(".ach-finish", b).addEventListener("click", e => { const t = e.target.closest("button"); if (!t) return; $$(".ach-finish button", b).forEach(x => x.classList.toggle("on", x === t)); finish = t.dataset.f; render(true); });
    btn.addEventListener("click", () => {
      const d = dist.value;
      if (!d || !parseFloat(d.replace(",", "."))) { dist.parentElement.animate([{ transform: "translateX(-6px)" }, { transform: "translateX(6px)" }, { transform: "none" }], { duration: 300 }); return toast(cfg.needDistance); }
      add([{ id: cfg.sports[sport].variant, quantity: 1, properties: { Distance: `${d} KM`, Finish: finish } }], btn);
    });
    render(false);
  });

  /* ---------- hero slideshow + counters ---------- */
  $$("[data-ach-hero]").forEach(h => {
    const imgs = $$(".ach-hero-img img", h), dots = $(".ach-dots", h); if (imgs.length < 2) return;
    let i = 0, timer;
    dots.innerHTML = imgs.map((_, k) => `<button type="button" aria-label="${k + 1}" class="${k ? "" : "on"}"></button>`).join("");
    const go = k => { i = k; imgs.forEach((im, j) => im.classList.toggle("on", j === k)); $$("button", dots).forEach((d, j) => d.classList.toggle("on", j === k)); };
    const start = () => { clearInterval(timer); timer = setInterval(() => go((i + 1) % imgs.length), 5000); };
    $$("button", dots).forEach((d, k) => d.addEventListener("click", () => { go(k); start(); }));
    start();
  });
  $$("[data-ach-count]").forEach(el => {
    const end = +el.dataset.achCount, t0 = performance.now();
    const f = t => { const k = Math.min(1, (t - t0) / 1400); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(f); };
    requestAnimationFrame(f);
  });

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { threshold: .15 });
  $$(".ach-reveal").forEach((el, i) => { el.style.transitionDelay = (i % 3) * 80 + "ms"; io.observe(el); });

  saveWish(); syncHearts(); refreshCart().catch(() => {});
})();
